export { OrganizationPage as default } from '@/components/pages/Ir/Governance/Organization'
